import type { ProcessingPipelineState } from '@/services/api/adminProcessing'

export const REFRESH_FAST_MS = 5000
export const REFRESH_SLOW_MS = 30000

export const RANGE_OPTIONS: Array<{ key: string; label: string; hours: number }> = [
  { key: '1h', label: '1h', hours: 1 },
  { key: '6h', label: '6h', hours: 6 },
  { key: '24h', label: '24h', hours: 24 },
  { key: '7d', label: '7d', hours: 24 * 7 },
  { key: '30d', label: '30d', hours: 24 * 30 },
  { key: 'all', label: 'All', hours: 24 * 365 * 10 },
]

export function formatMs(ms: number | null | undefined): string {
  if (ms == null) return '—'
  if (ms < 1000) return `${Math.round(ms)}ms`
  const s = ms / 1000
  if (s < 60) return `${s.toFixed(1)}s`
  const m = Math.floor(s / 60)
  const rs = Math.floor(s % 60)
  return `${m}m ${rs}s`
}

export function formatPct(v: number): string {
  return `${(v * 100).toFixed(1)}%`
}

export function durationToneClass(ms: number | null | undefined): string {
  if (ms == null) return 'text-muted-foreground'
  if (ms < 100) return 'text-muted-foreground'
  if (ms < 1000) return 'text-emerald-500'
  if (ms < 5000) return 'text-amber-500'
  if (ms < 30000) return 'text-orange-500'
  return 'text-red-500'
}

export function failureToneClass(rate: number): string {
  if (rate <= 0) return 'text-muted-foreground'
  if (rate < 0.01) return 'text-amber-500'
  if (rate < 0.05) return 'text-orange-500'
  return 'font-semibold text-red-500'
}

export type PipelineHealthLevel = 'ok' | 'warn' | 'bad'

export function healthLevelFor(p: ProcessingPipelineState): PipelineHealthLevel {
  if (!p.health.rabbit_ok || !p.health.db_ok) return 'bad'
  if (p.health.workers === 0) return 'warn'
  const failRate =
    p.metrics && p.metrics.jobs.done + p.metrics.jobs.failed > 0
      ? p.metrics.jobs.failed / (p.metrics.jobs.done + p.metrics.jobs.failed)
      : 0
  if (failRate >= 0.05) return 'bad'
  if (failRate >= 0.01) return 'warn'
  if ((p.queue?.ready ?? 0) > 100 && p.health.workers === 0) return 'warn'
  return 'ok'
}
